import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { hideLoader, showLoader } from '../../components/Loader/loaderSlice';
import { FloatingLabelInput } from '../../components';
import { MODAL_ANIMATION_DURATION } from '../../utils';
import { DashboardsService, NotificationsService } from '../../services';

const CreateEditPage: React.FC<PropsTypes> = ({ id, onClose, onSave }) => {
  const dispatch = useDispatch();
  const [description, setDescription] = useState('');
  const saveDisabled = useMemo(() => !description, [description]);

  useEffect(() => {
    const loadData = async () => {
      if (!id) {
        cleanFields();
        return;
      }

      dispatch(showLoader());
      try {
        const dashboard = await DashboardsService.findOneById(id);
        setDescription(dashboard.description);
      } catch (error) {
        console.error(error);
        NotificationsService.error({ message: 'Falha ao carregar Dashboard para Edição' });
        onClose();
      } finally {
        dispatch(hideLoader());
      }
    };

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onClickSave = async () => {
    const dashboardDescription = { description };

    try {
      if (!id) {
        await DashboardsService.create(dashboardDescription);
      } else {
        await DashboardsService.update(id, dashboardDescription);
      }
      onSave();
    } catch (error) {
      console.error(error);
      NotificationsService.error({ message: 'Falha ao Salvar Dashboard' });
    } finally {
      onClickCancel();
    }
  };

  const cleanFields = () => {
    setTimeout(() => {
      setDescription('');
    }, MODAL_ANIMATION_DURATION);
  };

  const onClickCancel = () => {
    onClose();
    cleanFields();
  };

  return (
    <div className="create-edit-page">
      <FloatingLabelInput
        label="Descrição"
        onChange={(e) => setDescription(e.currentTarget.value)}
        value={description}
      />
      <div className="field is-grouped is-grouped-right">
        <p className="control">
          <button className="button is-light" onClick={onClickCancel}>Cancelar</button>
        </p>
        <p className="control">
          <button
            className="button is-link"
            disabled={saveDisabled}
            onClick={onClickSave}
          >
            Salvar
          </button>
        </p>
      </div>
    </div>
  );
};

export default CreateEditPage;

type PropsTypes = {
  id?: string;
  onClose: () => void;
  onSave: () => void;
}
